<app-spinner></app-spinner>
<main class="app container">
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center justify-content-end brand">
      <img style="margin: 0px auto" src="/assets/img/login/logo.svg" alt="webtest logo" />
    </div>
    <div class="d-flex flex-column align-items-center">
      <h1 class="login-header text-center">Forgot Password</h1>
      <p class="text-center login-subheader">Password reset link will be sent to your email</p>
    </div>
    <form ngNativeValidate class="p-4" #ResetPasswordForm="ngForm" (ngSubmit)="sendPasswordReset()">
      <div *ngIf="isError" style="width:fit-content; margin:0px auto">
        <em class="text-danger">{{alert}}</em>
      </div>
      <div class="form-group mb-3" style="width:fit-content; margin:0px auto">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="bg-white mr-2 ml-2"><img src="/assets/img/login/sms.png" /></span>
          </div>
          <input id="email" type="email" class="form-control" placeholder="Email"
            [(ngModel)]="Email" name="email" #email="ngModel" required>
        </div>
      </div>
      
      <div class="d-flex flex-column">
        <button type="submit" class="d-flex justify-content-center align-items-center btn btn-lg login-btn px-4" [disabled]="!ResetPasswordForm.valid" style="width: 15vw; padding: 15px;">
          <span style=" width:fit-content ; margin: 0px auto">Reset Password</span>
        </button>
      </div>
      <div class="d-flex flex-column align-items-center">
        <a routerLink="/login" class="">Back To Login</a>
      </div>
    </form>
  </div>
</main>